{
  "de": {
    "directUpload": {
      "title": "Hochladen",
      "chooseFiles": "Dateien auswählen",
      "dropzone": {
        "textMultiple": "Dateien hier ablegen zum Hochladen",
        "text": "Datei hier ablegen zum Hochladen",
        "or": "oder",
        "browse": "durchsuchen"
      },
      "previewImage": {
        "remove": "Entfernen"
      },
      "actions": {
        "upload": "Hochladen",
        "close": "Schließen"
      }
    }
  }
}
